/* 说明
 * @插件文件: vue-ajax.js
 * @author: gaxoiang
*/

import axios from 'axios'

// 检查http状态码
function checkStatus (response, str) {
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
  }
  if (str === 'check') {
    if (response.success !== 1) {
      return {
        status: -404,
        msg: '网络异常'
      }
    }
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

// 根据返回数据的code做不同处理
function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    alert('网络异常')
    return
  }
  return res.data
}

function errorTip (rej, obj) {
  if (rej) {
    alert('网络错误')
  }
}

export default {
  install (Vue, options) {
    Vue.prototype.$vget = (url, params, res, str) => {
      return axios({
        method: 'get',
        url,
        params
      }).then((response) => {
        return checkStatus(response, str)
      }).then((res) => {
        return checkCode(res)
      }).then(res).catch((rej) => {
        errorTip(rej)
      })
    }
    Vue.prototype.$vpost = (url, data, res) => {
      return axios({
        method: 'post',
        url,
        data
      }).then((response) => {
        return checkStatus(response)
      }).then((res) => {
        return checkCode(res)
      }).then(res).catch((rej) => {
        errorTip(rej)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/vue-ajax.js